import { tooltipClasses } from "@mui/material";
import { type CSSObject, type SxProps, type Theme } from "@mui/material/styles";

import { type TooltipProps, type TooltipVariant } from "ui/tooltip/tooltip.types";

/** The element the tooltip anchors to. Inline, so a tooltip does not change the layout it sits in. */
export const TOOLTIP_WRAPPER_SX: SxProps<Theme> = { position: "relative", display: "inline-block" };

/** `dark` is the theme's own surface (`theme/components/tooltip.ts`). */
export const TOOLTIP_VARIANT_SX: Record<TooltipVariant, SxProps<Theme>> = {
  dark: {},
  light: (theme) => ({
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    [`& .${tooltipClasses.arrow}`]: { color: theme.palette.background.paper },
  }),
};

export const getTooltipSizeSx = (
  width: TooltipProps["width"],
  maxWidth: TooltipProps["maxWidth"],
): CSSObject => ({
  width,
  maxWidth: maxWidth ?? (width === undefined ? undefined : "none"),
});
